import React from "react";
import HighlightCard from "./HighlightCard";
import { PiDropFill } from "react-icons/pi";
import { PiTreeFill } from "react-icons/pi";

interface DropsHighlightProps {
  dropsNeeded: number;
  dropsCount: number;
  onClick: () => void;
}

const DropsHighlight: React.FC<DropsHighlightProps> = ({
  dropsNeeded,
  dropsCount,
  onClick,
}) => {
  let variant: "blue"|"green";
  let icon: JSX.Element;
  let subtitle: JSX.Element;
  let progressStyle: React.CSSProperties = {};

  if (dropsCount >= dropsNeeded) {
    variant = "green";
    icon = <PiTreeFill className="w-8 h-8 text-white" />;
    subtitle = (
      <>
        Press the icon{" "}
        <span className="font-semibold">to plant your next tree! ⤴</span>
      </>
    );
    progressStyle = {
      borderRadius: "50%",
      boxShadow: "0 10px 20px rgba(0, 0, 0, 0.3), 0 6px 6px rgba(0, 0, 0, 0.22)",
      cursor: "pointer",
    };
  } else {
    variant = "blue";
    icon = <PiDropFill className="w-8 h-8 text-white" />;
    subtitle = (
      <span>
        Earn <span className="font-semibold">{dropsNeeded - dropsCount} more drops</span>{" "}
        to plant <span className="font-semibold">your next tree</span>
      </span>
    );
  }

  const totalDrops = dropsNeeded;
  const progressVal = (dropsCount / (dropsNeeded)) * 100;

  const handleClick = () => {
    if (dropsCount >= dropsNeeded) {
      onClick(); // starts the animation
    }
  };

  return (
    <HighlightCard
      title={
        <>
          You have{" "}
          <span className="font-bold">
            {dropsCount}/{totalDrops}
          </span>{" "}
          Water Drops
        </>
      }
      subtitle={subtitle}
      variant={variant}
      progressVal={progressVal}
      progressStyle={progressStyle}
      icon={icon}
      onClick={handleClick}
    />
  );
};

export default DropsHighlight;